import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { getCountries } from '../../actions/userActions/countryAction'
import { addCities, updateCities } from '../../actions/userActions/cityAction'
import { Redirect, useLocation, useHistory } from 'react-router-dom';
import { CircularProgress, IconButton } from '@mui/material'
import HrComponent from '../reuse_components/HrComponent'
import SingleSelect from '../designSystem/SingleSelect'
import BodyLargeMedium from '../designSystem/BodyLargeMedium'
import BodySmallMedium from '../designSystem/BodySmallMedium'
import BodySmallRegular from '../designSystem/BodySmallRegular'
import BodyExtraSmallMedium from '../designSystem/BodyExtraSmallMedium'
import cityicon from "../../assets/images/cityIcon (2).svg";
import closeModal from "../../assets/images/closeModal.svg";
import "../DesignationLevel/DynamicModal.css";
import TextField from '../designSystem/TextField'
import { validateFields } from '../../utils/Validations';
import { Check, X } from 'lucide-react';
import CancelButton from '../subComponents/buttons/CustomCancelButton';
import PrimaryButton from '../subComponents/buttons/PrimaryButton';
import { t } from '../../locales/translate';
import LoadingOverlay from "../loadingOverlay/LoadingOverlay";

function AddCities({ onClose, editData, onSave }) {

  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const initialValues = { name: "", shortName: "", countryId: "" };
  const [formValues, setFormValues] = useState(initialValues);
  const [formErrors, setFormErrors] = useState({});
  const countries = useSelector(state => state.countries_reducer.countries);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
  const fetchData = async () => {
    setLoading(true);
    try {
      await dispatch(getCountries());
    } catch (error) {
      console.error("Error fetching countries:", error);
    } finally {
      setLoading(false);
    }
  };
  fetchData();
}, []);
  useEffect(() => {
    if (editData) {
      setFormValues(editData);
    }
  }, [editData]);
 const handleSave = async (e) => {
  e.preventDefault();
  const errors = validateFields(formValues, 'city');
  setFormErrors(errors);
  if (Object.keys(errors).length > 0) return;
  
  setLoading(true);
  try {
    if (editData) {
      await dispatch(updateCities(formValues));
    } else {
      await dispatch(addCities(formValues));
    }
    setLoading(false);
    onSave(formValues);
  } catch (error) {
    console.error("Error saving city:", error);
    setLoading(false);
  }
};
  const handleCountryChange = (event) => {
    setFormValues({
      ...formValues,
      countryId: event.value
    })
  }
  const getOptions = () => {

    return (
      countries &&
      countries !== "isLoading" &&
      countries.length !== 0 &&
      countries.result && countries.result.length !== 0 && countries.result
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((countries) => ({
          value: countries.id,
          label: countries.name

        }))
    ) || [];
  };


  const handleNameChange = (event) => {
    setFormValues({
      ...formValues,
      name: event.target.value
    });
  };
  const handleShortnameChange = (event) => {
    setFormValues({
      ...formValues,
      shortName: event.target.value
    });
  };
  return (
  <>
    <div className="dynamicmodal-overlay">
      <div className="dynamicmodal-container overlay-wrapper">
        <LoadingOverlay isVisible={loading} />
        <div className={loading ? 'blur' : ''}>
          <div className="dynamicmodal-header mb-3">
            <div className="dynamicmodal-header-left">
              <div className="icon">
                <img src={cityicon} alt="city" />
              </div>
              <div className="">
                <h2 className="modalheading">
                  {editData ? "Edit City" :  `${t("addCities")}`}
                </h2>
                <p className="modaldescription">{t("addCitiesTip")}</p>

              </div>
            </div>
            <div className="dynamicmodal-header-right">
              <IconButton onClick={onClose}>
                <img src={closeModal} alt="" />
              </IconButton>
            </div>
          </div>


          <form onSubmit={handleSave}>
            <div className="dynamicmodal-body">

              <div className="dynamicmodal-form-group">
                <TextField
                  label={`${t("name")} *`}
                  type='text'
                  value={formValues.name}
                  onChange={handleNameChange}
                  placeholder={t("name")}
                  error={formErrors.name}
                />
              </div>
              <div className="dynamicmodal-form-group">

                <TextField
                  label={`${t("shortName")} *`}
                  type='text'
                  value={formValues.shortName}
                  onChange={handleShortnameChange}
                  placeholder={t("shortName")}
                  error={formErrors.shortName}
                />
              </div>
              <SingleSelect
                label={`${t("country")} *`}
                secondaryLabel
                iconEnd
                onChange={handleCountryChange}
                value={formValues.countryId}
                error={formErrors.countryId}
                placeholder={t("country")}
                options={(countries &&
                  countries !== "isLoading" &&
                  countries.length !== 0 && countries.result &&
                  countries.result.length !== 0)
                  && getOptions()}
              />

            </div>
           <div className="dynamicmodal-footer">
              <CancelButton
              onClick={onClose}
              text={t("cancel")}
              width={document.body.dir === "rtl" ? "119px" : ""}
              />
              <PrimaryButton
              text={t("save")}
              icon={Check}
              width={document.body.dir === "rtl" ? "123px" : ""}
              />
          </div>
          </form>
        </div>
      </div>
      </div>

    </>
  )
}

export default AddCities